import { InspectionNote, InspectionVM } from '../inspections';
import { FormActivity, FormActivityModel } from './form-activity';
export class InspectionActivityModel extends FormActivityModel {
  inspection: InspectionVM;
  allowCancel: boolean;
  allowBypass: boolean;
  rescheduleReason: InspectionNote;
  isCanceled: boolean;
  cancelReason: InspectionNote;
  isBypassed: boolean;
  bypassReason: InspectionNote;
  requestActivityResponsibleRole: string;
  scheduleActivityResponsibleRole: string;
  requestActivityScreenName: string;
  scheduleActivityScreenName: string;
  
  constructor(options: { [key: string]: any }) {
    super(options);
    this.inspection = new InspectionVM();

    if (options && options.inspection) {
      Object.assign(this.inspection, options.inspection);
    }
  }
}
export class InspectionRequestActivity extends FormActivity<
  InspectionActivityModel
> {
  constructor(options?: Partial<InspectionRequestActivity>) {
    super(options);

    if (options) {
      Object.assign(this, options);
    }

    this.model = new InspectionActivityModel(options ? options.model : null);
  }
}
